import { PropertyAPI } from "@griffingroupglobal/eslib-api";

const postSpaceToProperty = async ({ payload, id }) => {
  const { data } = await PropertyAPI.postWOP(`${id}/$addspace`, payload);

  return data;
};

export default postSpaceToProperty;
